<template>
  <a href="/"
    ><svg
      width="100%"
      height="50"
      viewBox="0 0 235 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4935 5.9895L45 19.142V16.8122L33.6799 10.1744L22.4935 3.59802L0.000854492 16.7506V19.142L22.4935 5.9895Z"
        fill="url(#paint0_linear_362_5371)"
      />
      <path
        d="M22.4935 11.6743L45 24.8268V22.497L33.6799 15.8592L22.4935 9.28284L0.000854492 22.4355V24.8268L22.4935 11.6743Z"
        fill="url(#paint1_linear_362_5371)"
      />
      <path
        d="M44.9054 27.7038V43.8062L27.813 53.4745L22.4636 56.5L17.1142 53.4745L0 43.7944V27.692L5.37442 24.6047V40.7828L22.4636 50.448L39.531 40.7946V24.6175L44.9054 27.7038Z"
        fill="url(#paint2_linear_362_5371)"
      />
      <g clip-path="url(#clip0_362_5371)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24.1447 16.0812V46.1612L28.8757 43.4363V34.0558L36.8946 29.3684V23.5432L24.1447 16.0812ZM32.21 28.2306L28.8757 30.142V22.7241L32.21 24.6809V28.2306Z"
          fill="url(#paint3_linear_362_5371)"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.8554 16.0812V46.1612L16.1243 43.4292V32.1174L12.7901 34.0558V41.4738L8.10547 38.7418V23.5432L12.7901 20.7686V30.142L16.1243 28.2306V18.8572L20.8554 16.0812Z"
          fill="url(#paint4_linear_362_5371)"
        />
      </g>
      <path
        d="M64.75 30.5H61V15.5H64.75V21.2H72.25V15.5H76V30.5H72.25V24.875H64.75V30.5ZM78.2422 15.5H83.1422L86.8422 20.05C88.2422 18.325 89.1672 17.2 90.5672 15.5H95.4422L88.7172 23.675V30.5H84.9672V23.675L78.2422 15.5ZM101.444 30.5H97.6943V15.5H107.694C111.044 15.5 112.694 17.15 112.694 20.5C112.694 23.85 111.044 25.5 107.694 25.5H101.444V30.5ZM101.444 19.25V21.85H107.694C108.544 21.85 108.969 21.5 108.944 20.5C108.919 19.65 108.544 19.25 107.694 19.25H101.444ZM129.687 26.775V30.5H114.687V15.5H129.687V19.275H118.437V21.15H124.062V24.875H118.437V26.775H129.687ZM135.429 30.5H131.679V15.5H141.679C145.029 15.5 146.679 17.15 146.679 20.5C146.679 23.025 145.754 24.575 143.879 25.2L147.054 30.5H142.629L139.704 25.5H135.429V30.5ZM135.429 19.175V21.825H141.679C142.529 21.825 142.929 21.35 142.929 20.5C142.929 19.65 142.529 19.175 141.679 19.175H135.429ZM163.937 20C163.937 20.825 163.837 21.625 163.587 22.325C164.237 23.075 164.562 24.15 164.562 25.5C164.562 28.45 162.912 30.5 159.562 30.5H149.562V15.5H159.312C162.687 15.5 163.937 17.525 163.937 20ZM153.312 24.625V27H159.562C160.412 27 160.812 26.475 160.812 25.725C160.812 25.175 160.462 24.675 159.737 24.625H153.312ZM153.312 19V21.125H159.262C159.837 21.125 160.137 20.5 160.137 20.05C160.137 19.625 159.812 19 159.187 19H153.312ZM175.697 30.5H171.947C168.197 30.5 166.322 28.625 166.322 24.875V21.125C166.322 17.375 168.197 15.5 171.947 15.5H175.697C179.447 15.5 181.322 17.375 181.322 21.125V24.875C181.322 28.625 179.447 30.5 175.697 30.5ZM171.947 26.825H175.697C176.947 26.825 177.572 26.2 177.572 24.95V21.075C177.572 19.825 176.947 19.2 175.697 19.2H171.947C170.697 19.2 170.072 19.825 170.072 21.075V24.95C170.072 26.2 170.697 26.825 171.947 26.825ZM183.705 15.5H187.455V26.825H197.455V30.5H183.705V15.5ZM203.802 30.5H200.052V15.5H203.802V30.5ZM221.19 26.8V30.5H211.815C208.065 30.5 206.19 28.625 206.19 24.875V21.125C206.19 17.375 208.065 15.5 211.815 15.5H221.19V19.2H211.815C210.565 19.2 209.94 19.825 209.94 21.075V24.925C209.94 26.175 210.565 26.8 211.815 26.8H221.19Z"
        fill="url(#paint5_linear_362_5371)"
      />
      <path
        d="M63.8 46.5H60.8V34.5H68.8C71.48 34.5 72.8 35.82 72.8 38.5C72.8 41.18 71.48 42.5 68.8 42.5H63.8V46.5ZM63.8 37.5V39.58H68.8C69.48 39.58 69.82 39.3 69.8 38.5C69.78 37.82 69.48 37.5 68.8 37.5H63.8ZM77.0338 46.5H74.0338V34.5H82.0338C84.7138 34.5 86.0338 35.82 86.0338 38.5C86.0338 40.52 85.2938 41.76 83.7938 42.26L86.3338 46.5H82.7938L80.4538 42.5H77.0338V46.5ZM77.0338 37.44V39.56H82.0338C82.7138 39.56 83.0338 39.18 83.0338 38.5C83.0338 37.82 82.7138 37.44 82.0338 37.44H77.0338ZM95.08 46.5V43.56C96.08 43.56 96.58 43.06 96.58 42.06V38.96C96.58 37.96 96.08 37.46 95.08 37.46H92.08C91.08 37.46 90.58 37.96 90.58 38.96V42.06C90.58 43.06 91.08 43.56 92.08 43.56H95.08V46.5H92.08C89.08 46.5 87.58 45 87.58 42V39C87.58 36 89.08 34.5 92.08 34.5H95.08C98.08 34.5 99.58 36 99.58 39V42C99.58 45 98.08 46.5 95.08 46.5ZM108.626 46.5H105.626V37.42H101.126V34.5H113.126V37.42H108.626V46.5ZM121.86 46.5V43.56C122.86 43.56 123.36 43.06 123.36 42.06V38.96C123.36 37.96 122.86 37.46 121.86 37.46H118.86C117.86 37.46 117.36 37.96 117.36 38.96V42.06C117.36 43.06 117.86 43.56 118.86 43.56H121.86V46.5H118.86C115.86 46.5 114.36 45 114.36 42V39C114.36 36 115.86 34.5 118.86 34.5H121.86C124.86 34.5 126.36 36 126.36 39V42C126.36 45 124.86 46.5 121.86 46.5ZM139.906 43.54V46.5H132.406C129.406 46.5 127.906 45 127.906 42V39C127.906 36 129.406 34.5 132.406 34.5H139.906V37.46H132.406C131.406 37.46 130.906 37.96 130.906 38.96V42.04C130.906 43.04 131.406 43.54 132.406 43.54H139.906ZM149.05 46.5V43.56C150.05 43.56 150.55 43.06 150.55 42.06V38.96C150.55 37.96 150.05 37.46 149.05 37.46H146.05C145.05 37.46 144.55 37.96 144.55 38.96V42.06C144.55 43.06 145.05 43.56 146.05 43.56H149.05V46.5H146.05C143.05 46.5 141.55 45 141.55 42V39C141.55 36 143.05 34.5 146.05 34.5H149.05C152.05 34.5 153.55 36 153.55 39V42C153.55 45 152.05 46.5 149.05 46.5ZM155.096 34.5H158.096V43.56H166.096V46.5H155.096V34.5Z"
        fill="url(#paint6_linear_362_5371)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_362_5371"
          x1="0.000854492"
          y1="11.1345"
          x2="45"
          y2="11.1345"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFE200" />
          <stop offset="0.2" stop-color="#FF870A" />
          <stop offset="0.4" stop-color="#FF9200" />
          <stop offset="0.6" stop-color="#FF6B26" />
          <stop offset="0.8" stop-color="#FF3E54" />
          <stop offset="1" stop-color="#FF0093" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_362_5371"
          x1="0.000854492"
          y1="16.8193"
          x2="45"
          y2="16.8193"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFE200" />
          <stop offset="0.2" stop-color="#FF870A" />
          <stop offset="0.4" stop-color="#FF9200" />
          <stop offset="0.6" stop-color="#FF6B26" />
          <stop offset="0.8" stop-color="#FF3E54" />
          <stop offset="1" stop-color="#FF0093" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_362_5371"
          x1="-4.50857"
          y1="40.4688"
          x2="44.9054"
          y2="40.4688"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00DAEE" />
          <stop offset="0.2" stop-color="#348CFF" />
          <stop offset="0.4" stop-color="#3981FC" />
          <stop offset="0.6" stop-color="#4765F5" />
          <stop offset="0.8" stop-color="#5F38EA" />
          <stop offset="1" stop-color="#652DE8" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_362_5371"
          x1="24.1447"
          y1="30.6654"
          x2="36.8946"
          y2="30.6654"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFE200" />
          <stop offset="1" stop-color="#FF870A" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_362_5371"
          x1="8.10547"
          y1="30.6654"
          x2="20.8554"
          y2="30.6654"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFE200" />
          <stop offset="1" stop-color="#FF870A" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_362_5371"
          x1="60"
          y1="24.0758"
          x2="225"
          y2="24.0758"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#FFE200" />
          <stop offset="1" stop-color="#FF870A" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_362_5371"
          x1="48.8554"
          y1="40.9502"
          x2="171"
          y2="40.9502"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00DAEE" />
          <stop offset="0.2" stop-color="#348CFF" />
          <stop offset="0.4" stop-color="#3981FC" />
          <stop offset="0.6" stop-color="#4765F5" />
          <stop offset="0.8" stop-color="#5F38EA" />
          <stop offset="1" stop-color="#652DE8" />
        </linearGradient>
        <clipPath id="clip0_362_5371">
          <rect
            width="28.7891"
            height="30.08"
            fill="white"
            transform="translate(8.10547 16.0812)"
          />
        </clipPath>
      </defs>
    </svg>
  </a>
</template>
